import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from '@angular/core';
import { ICoordinatesEvent, IHsl } from './color-picker.type';

@Component({
  selector: 'bixi-color-hue',
  exportAs: 'bixiColorHue',
  host: {
    '[class.bixi-color-hue]': 'true'
  },
  template: `
  <div class="bixi-color-hue-inner" bixi-coordinates (coordinatesChange)="onCoordinatesChange($event)">
    <div class="bixi-color-hue-pointer" [style.left.%]="pointerLeft">
      <div class="bixi-color-circle"></div>
    </div>
  </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BixiColorHueComponent implements OnChanges {
  pointerLeft: number;
  @Input() hsl: IHsl;
  @Output() colorChange = new EventEmitter<IHsl>();

  ngOnChanges(): void {
    this.pointerLeft = this.hsl.h * 100 / 360;
  }

  onCoordinatesChange(event: ICoordinatesEvent): void {
    const { left, width } = event;
    let h: number;
    if (left < 0) {
      h = 0;
    } else if (left > width) {
      h = 359;
    } else {
      const percent = left * 100 / width;
      h = 360 * percent / 100;
    }

    if (this.hsl.h !== h) {
      const color: IHsl = {
        ...this.hsl,
        h
      };
      this.colorChange.emit(color);
    }
  }
}
